"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opportunity = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_challenges_entity_1 = require("./opportunity-challenges.entity");
const opportunity_claim_experience_entity_1 = require("./opportunity-claim-experience.entity");
const opportunity_competitor_entity_1 = require("./opportunity-competitor.entity");
const opportunity_document_entity_1 = require("./opportunity-document.entity");
const opportunity_risk_locations_entity_1 = require("./opportunity-risk-locations.entity");
const company_entity_1 = require("./company.entity");
const contact_entity_1 = require("./contact.entity");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_previous_placement_details_entity_1 = require("./opportunity-previous-placement-details.entity");
const opportunity_previous_mediator_details_entity_1 = require("./opportunity-previous-mediator-details.entity");
const opportunity_contact_map_entity_1 = require("./opportunity-contact-map.entity");
const opportunity_cover_entity_1 = require("./opportunity-cover.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const opportunity_activity_participants_entity_1 = require("./opportunity-activity-participants.entity");
const user_1 = require("./user");
const policy_entity_1 = require("./policy.entity");
let Opportunity = class Opportunity {
    constructor(opportunityId, companyId, contactId, estimatedBrokerage, policyTypeLid, policyStatusLid, serviceLevelLid, soExpireDate, sumInsured, premiumPaid, stageLid, referredBy, sharingPercentage, estimatedFee, prevInsurerId, prevInsurerLocationId, prevInsurerBranchId, prevTpaId, prevTpaLocationId, prevTpaBranchId, remarks, opportunityTypeLid, isPolicyMinedLid, source, opportunitySourceTypeLid, salesPitch, ownerId, createdAt, updatedAt, deletedAt, createdBy, updatedBy) {
        this.opportunityId = opportunityId;
        this.companyId = companyId;
        this.contactId = contactId;
        this.estimatedBrokerage = estimatedBrokerage;
        this.policyTypeLid = policyTypeLid;
        this.policyStatusLid = policyStatusLid;
        this.serviceLevelLid = serviceLevelLid;
        this.soExpireDate = soExpireDate;
        this.sumInsured = sumInsured;
        this.premiumPaid = premiumPaid;
        this.stageLid = stageLid;
        this.referredBy = referredBy;
        this.sharingPercentage = sharingPercentage;
        this.estimatedFee = estimatedFee;
        this.prevInsurerId = prevInsurerId;
        this.prevInsurerLocationId = prevInsurerLocationId;
        this.prevInsurerBranchId = prevInsurerBranchId;
        this.prevTpaId = prevTpaId;
        this.prevTpaLocationId = prevTpaLocationId;
        this.prevTpaBranchId = prevTpaBranchId;
        this.remarks = remarks;
        this.opportunityTypeLid = opportunityTypeLid;
        this.isPolicyMinedLid = isPolicyMinedLid;
        this.source = source;
        this.opportunitySourceTypeLid = opportunitySourceTypeLid;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.deletedAt = deletedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.salesPitch = salesPitch;
        this.ownerId = ownerId;
    }
};
exports.Opportunity = Opportunity;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "estimated_brokerage", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "estimatedBrokerage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "policyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "policyStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_level_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "serviceLevelLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "so_expire_date", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Opportunity.prototype, "soExpireDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sum_insured", type: "float" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "premium_paid", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "premiumPaid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "stage_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "stageLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "referred_by", type: "varchar", length: 255, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Opportunity.prototype, "referredBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sharing_percentage", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "sharingPercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "estimated_fee", type: "float", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "estimatedFee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_insurer_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevInsurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_insurer_location_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevInsurerLocationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_insurer_branch_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevInsurerBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_tpa_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevTpaId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_tpa_location_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevTpaLocationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "prev_tpa_branch_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "prevTpaBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Opportunity.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "opportunityTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_policy_mined_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "isPolicyMinedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "source", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Opportunity.prototype, "source", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "source_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "opportunitySourceTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sales_pitch", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Opportunity.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Opportunity.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Opportunity.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Opportunity.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "owner_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Opportunity.prototype, "ownerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User, (user) => user.userId, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "owner_id", referencedColumnName: "userId" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "owner", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "source_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunitySourceType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "is_policy_mined_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "isPolicyMined", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_challenges_entity_1.OpportunityChallenges, (opportunityChallenges) => opportunityChallenges.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityChallenges", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_claim_experience_entity_1.OpportunityClaimExperiences, (opportunityClaimExperiences) => opportunityClaimExperiences.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityClaimExperiences", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_competitor_entity_1.OpportunityCompetitors, (opportunityCompetitors) => opportunityCompetitors.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityCompetitors", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_document_entity_1.OpportunityDocuments, (opportunityDocuments) => opportunityDocuments.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityDocuments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_risk_locations_entity_1.OpportunityRiskLocations, (opportunityRiskLocations) => opportunityRiskLocations.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityRiskLocations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.opportunities, {
        cascade: false,
        nullable: false,
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "policyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_status_lid" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "policyStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "stage_lid" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "stage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "service_level_lid" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "serviceLevel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_previous_placement_details_entity_1.OpportunityPreviousPlacementDetails, (previousPlacementDetails) => previousPlacementDetails.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "previousPlacementDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_previous_mediator_details_entity_1.OpportunityPreviousMediatorDetails, (previousMediatorDetails) => previousMediatorDetails.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Opportunity.prototype, "previousMediatorDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_contact_map_entity_1.OpportunityContactMap, (opportunityContactMap) => opportunityContactMap.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Opportunity.prototype, "opportunityContactMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_cover_entity_1.OpportunityCoverMap, (cover) => cover.opportunity, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Opportunity.prototype, "covers", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_activity_map_entity_1.OpportunityActivityMap, (opportunityActivityMap) => opportunityActivityMap.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityActivityMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_entity_1.Policy, (Policy) => Policy.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "policy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_activity_participants_entity_1.OpportunityActivityParticipants, (opportunityActivityParticipants) => opportunityActivityParticipants.opportunity, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], Opportunity.prototype, "opportunityActivityParticipants", void 0);
exports.Opportunity = Opportunity = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, Number, Number, Number, String, Number, Number, Number, Number, Number, Number, Number, Number, String, Number, Number, String, Number, String, Number, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object, Number, Number])
], Opportunity);
